const projectImage1 = "/images/projects-section/after1.webp";
const projectImage2 = "/images/projects-section/after2.webp";
const projectImage3 = "/images/projects-section/after3.webp";
const projectImage4 = "/images/projects-section/after4.webp";

const basePath =
	"/images/projectspage/Projects-20251214T144209Z-1-001/Projects";

// Image arrays for each project
const projectImages = {
	Shangrila: [
		`${basePath}/Shangrila/DSC00017.webp`,
		`${basePath}/Shangrila/DSC00022.webp`,
		`${basePath}/Shangrila/DSC00057.webp`,
		`${basePath}/Shangrila/DSC00102.webp`,
		`${basePath}/Shangrila/DSC09870.webp`,
		`${basePath}/Shangrila/DSC09875.webp`,
		`${basePath}/Shangrila/DSC09878.webp`,
		`${basePath}/Shangrila/IMG_3008.webp`,
		`${basePath}/Shangrila/IMG_3027.webp`,
		`${basePath}/Shangrila/IMG_5533.webp`,
		`${basePath}/Shangrila/Img_9297.webp`,
		`${basePath}/Shangrila/WhatsApp Image 2025-07-28 at 11.05.10 AM (1).webp`,
	],
	"Skye-20": [
		`${basePath}/Skye20/DSC00167-Edit-Edit.webp`,
		`${basePath}/Skye20/DSC00004-Edit.webp`,
		`${basePath}/Skye20/DSC00100-Edit.webp`,
		`${basePath}/Skye20/DSC00229-Edit.webp`,
		`${basePath}/Skye20/DSC00231-Edit.webp`,
		`${basePath}/Skye20/DSC00233.webp`,
		`${basePath}/Skye20/DSC09927-HDR-Edit.webp`,
		/*`${basePath}/Skye20/DSC09934-Edit.webp`,*/
		/*`${basePath}/Skye20/eveninghourEdit.webp`,*/
	],
	"Skye Privilion ": [
		`${basePath}/Skyeprivilion/DSC00007-Edit.webp`,
		`${basePath}/Skyeprivilion/DSC00040-HDR-Edit.webp`,
		`${basePath}/Skyeprivilion/DSC00052-HDR-Edit.webp`,
		`${basePath}/Skyeprivilion/DSC00081-Edit.webp`,
		`${basePath}/Skyeprivilion/DSC00084-Edit.webp`,
		`${basePath}/Skyeprivilion/DSC00086-Edit.webp`,
	],
	"Sahil's Office": [
		`${basePath}/Sahil_soffice/DSC04034-HDR.webp`,
		`${basePath}/Sahil_soffice/DSC04038-HDR.webp`,
		`${basePath}/Sahil_soffice/DSC04043.webp`,
		`${basePath}/Sahil_soffice/DSC04045.webp`,
		`${basePath}/Sahil_soffice/DSC04048.webp`,
		`${basePath}/Sahil_soffice/DSC04049-HDR.webp`,
		`${basePath}/Sahil_soffice/tableonlyshot.webp`,
	],
	"Saffron House Office": [
		`${basePath}/Saffronhouseoffice/saffronhouseimage.jpeg`,
	],
	"Sodani Residence": [`${basePath}/Sodani_s/sodaniimage1.webp`],
	"Siddhi Vinayak Office": [
		`${basePath}/Siddhivinayak-Office/Image.png`,
		`${basePath}/Siddhivinayak-Office/BoardRoom.png`,
		`${basePath}/Siddhivinayak-Office/Waiting.png`,
		`${basePath}/Siddhivinayak-Office/Scene3.png`,
	],
	"The Sanctuary": [`${basePath}/thesanctuary/Image_1.webp`],
};

export const DATA = [
	{
		title: "Shangrila",
		image: projectImage1,
		images: projectImages["Shangrila"],
		tagline: "A model residence that balances refinement with warmth",
		subtitle: "",
		client: "Mr. Sahil Kandhrol",
		location: "Shangri-la, Talawali Chanda, Indore",
		duration: "6 months",
		space:
			"This 1200 sq. ft. sample apartment was envisioned as a showcase of understated elegance. The raw flat offered a blank canvas where proportion, flow, and balance could be crafted into a living environment that would resonate with potential buyers.",
		ask: "The client sought an interior that would not only highlight the architectural strengths of the apartment but also set a distinct tone of sophistication—subtle, layered, and inviting.",
		result:
			"The apartment was transformed into a space defined by quiet luxury. A restrained palette, warm textures, and carefully layered details created an environment that felt both elevated and comfortable. Each room was designed to flow seamlessly, enhancing the perception of scale while maintaining intimacy.",
		type: "Residential",
	},
	{
		title: "Skye-20",
		image: projectImage2,
		images: projectImages["Skye-20"],
		subtitle: "",
		tagline: "A calm and contemporary home rooted in tonal harmony",
		client: "Mr. Yogesh Kaushal",
		location: "Skye-20, Vijay Nagar, Indore",
		duration: "5 months",
		space:
			"With 2002 sq. ft. to work with, the residence offered generous proportions and natural light—ideal for creating a serene home. The design approach emphasized openness and fluidity while retaining distinct character across each space.",
		ask: "The family wanted a home that would reflect simplicity and balance. Their brief focused on calm interiors that allowed for comfortable living without unnecessary excess.",
		result:
			"The home was designed around tonal restraint—layering soft textures, neutral hues, and gentle contrasts. The result is a residence that radiates serenity, where each space feels intentional and timeless, offering a calm backdrop for daily life.",
		type: "Residential",
	},
	{
		title: "Sodani Residence",
		image: projectImage3,
		images: projectImages["Sodani Residence"],
		subtitle: "",
		tagline: "A contemporary home rooted in tonal harmony",
		client: "Dr. Madan Sodani",
		location: "Apollo DB City, Nipania",
		duration: "Ongoing",
		space:
			"A 2700 sq. ft. residence that will combine expansiveness with warmth, tailored to modern family living.",
		ask: "The client envisions a home that balances modern aesthetics with comfort, ensuring every space feels personal yet connected.",
		type: "Residential",
	},
	{
		title: "The Sanctuary",
		image: projectImage1,
		images: projectImages["The Sanctuary"],
		subtitle: "",
		tagline: "A compact city retreat designed with intention",
		client: "Mr. Diljot Chabbra",
		location: "Andheri West, Mumbai",
		duration: "Ongoing",
		space:
			"This 650 sq. ft. residence is planned as an intimate retreat, a sanctuary within the bustle of Mumbai city life.",
		ask: "The brief emphasizes creating a calm, character-rich environment, maximizing efficiency within a compact footprint.",
		type: "Residential",
	},
	{
		title: "Skye Privilion ",
		image: projectImage1,
		images: projectImages["Skye Privilion "],
		subtitle: "",
		tagline: "A bold and welcoming workspace",
		client: "Mr. Vaibhav Maheshwari",
		location: "Skye Privilion, Nipania",
		duration: "6 months",
		space:
			"350 sq. ft. of raw commercial space, envisioned as a premium sales office. With ample light and height, it provided the opportunity to craft a compact yet impactful workspace.",
		ask: "The client wanted an office that would feel confident, professional, and aspirational, breaking away from standard developer spaces.",
		result:
			"A striking office emerged—defined by deep green tones, warm textures, and thoughtful zoning. The result is a space that feels both contemporary and inviting, making a lasting impression on every visitor.",
		type: "Commercial",
	},
	{
		title: "Sahil's Office",
		image: projectImage2,
		images: projectImages["Sahil's Office"],
		subtitle: "",
		tagline: "A refined workspace blending professionalism and style",
		client: "Mr. Sahil Kandhari",
		location: "Sahil Infinite, Bicholi Mardana",
		duration: "7 months",
		space:
			"450 sq. ft. of office space that required thoughtful planning to balance openness with privacy, functionality with aesthetics.",
		ask: "The brief was to design a modern workspace that aligned with the client’s professional identity while offering a welcoming environment.",
		result:
			"The design centered around clean lines, warm finishes, and layered lighting to create a workspace that is polished yet approachable. Each corner was tailored for efficiency without losing its elegance.",
		type: "Commercial",
	},
	{
		title: "Siddhi Vinayak Office",
		image: projectImage3,
		images: projectImages["Siddhi Vinayak Office"],
		subtitle: "- Coming Soon",
		tagline: "A modern office designed for grandeur and grace",
		client: "Mr. Piyush Mishra",
		location: "Singapore Business Park, LIG",
		duration: "Ongoing",
		space:
			"472 sq. ft. of commercial space that will be transformed into a contemporary office, both compact and efficient.",
		ask: "The client seeks a professional environment that conveys efficiency while remaining approachable and modern.",
		result: "",
		type: "Commercial",
	},
	{
		title: "Saffron House Office",
		image: projectImage4,
		images: projectImages["Saffron House Office"],
		subtitle: "",
		tagline: "A creative home of the design studio",
		client: "Saffron House",
		location: "Skye pavilion, Nipania",
		duration: "Ongoing",
		space:
			"Spread across 650 sq. ft., this will be the principal studio of Saffron House, conceived as both a creative workspace and a space designed to host clients with warmth and elegance.",
		ask: " The office will embody the philosophy and design language of the studio, merging functionality with the warmth and detail that define its work.",
		result: "",
		type: "Commercial",
	},
];
